import { PrismicRichText } from "@prismicio/react";
import React from 'react';
import Slider from "react-slick";

export const ResourceQuote = (props) => {

    const sc = props.slice.primary;

    const quotes = props.slice.items;

    const components = {
        label: ({ children }) => (
          <sup>{children}</sup>
        ),
    }

    function NextArrow(props) {
        const { className, onClick } = props;
        return (
          <div className={className} onClick={onClick} tabIndex="0">
            <div className="sr-only">Go to next slide</div>
            <i className="fa-solid fa-chevron-right text-grey-md text-3xl cursor-pointer" />
          </div>
        );
      }
    
      function PrevArrow(props) {
        const { className, onClick } = props;
        return (
          <div className={className} onClick={onClick} tabIndex="0">
            <div className="sr-only">Go to previous slide</div>
            <i className="fa-solid fa-chevron-left text-grey-md text-3xl cursor-pointer" />
          </div>
        );
      }
    
      const settings = {
        dots: true,
        appendDots: (dots) => (
          <ul aria-label="Slides">
            {dots}
          </ul>
        ),
        customPaging: (index) => {
          let slideNumber = index + 1;
          return (
            <button aria-label={`Slide ${slideNumber}`}></button>
          );
        },
        fade: true,
        infinite: true,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 7000,
        speed: 500,
        pauseOnHover: true,
        arrows: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        className: "resource-quote",
      };


    return (
        <section className="gutter top res-sec">
            <div className="wrapper pb-14 md:pb-24">
            <div className="w-auto text-center m-auto rounded-lg md:rounded-2xl md:w-3/4">
                <Slider className="flex" {...settings}>
                {quotes.map((quote, index) => {
                    return (
                        <div key={index} className="w-auto text-center m-auto md:w-3/4">
                            <div className="quotey mb-2 md:mb-8"><i className="fa-solid fa-quote-left text-4xl md:text-6xl" style={{color: sc.quote_color}} /></div>
                            <div className="text-base md:text-xl mb-8 text-grey"><PrismicRichText field={quote.quote.richText} components={components} /></div>
                            <span className="text-grey"><strong className="md:text-lg">{quote.quote_author}</strong><br />{quote.quote_author_title}</span>
                        </div>
                    )
                })}
                </Slider>
            </div>
            </div>
        </section>
    );
}

